export default "__VITE_ASSET__BiK8Ru3B__"